import type { RegularFilter, RegularFilterConfig, RegularFilterSelectedValues } from '../../models'
import type { IToolingFormComposableViewData } from './types'

export const getFiltersFromValues = (
  configs: Record<string, RegularFilterConfig>,
  values: Record<string, RegularFilterSelectedValues>,
  extraConfig?: IToolingFormComposableViewData['pivotsExtraConfig'],
): Record<string, RegularFilter> => {
  return Object.values(configs).reduce((result: Record<string, RegularFilter>, config) => {
    const { mandatory, multiselect } = extraConfig
      ? Object.assign({}, extraConfig.default, extraConfig[config.id])
      : { mandatory: undefined, multiselect: undefined }
    result[config.id] = {
      config: {
        ...config,
        ...(!!extraConfig && {
          mandatory,
          multiselectDisabled: !multiselect,
        }),
      },
      selectedValues: values[config.id] ?? [],
    }
    return result
  }, {})
}
